import { get } from 'lodash-es';
import Lockr from 'utils/local-store';
import type { RootState } from 'reducers';
import { createDeepEqualSelector } from 'selectors/selector-utils';
// Untyped .js module — INVITE_TOKEN_ID resolves as any.
import { INVITE_TOKEN_ID } from '../utils';

interface UserInvite {
  token: string;
  [key: string]: unknown;
}

// Deep-equal memoized so useSelector gets a stable reference; the Lockr read
// is an input selector, so declined invites are still re-read every call.
export const selectInvites = createDeepEqualSelector(
  (state: RootState) => get(state, 'userClient.userInvites.invites', []) as UserInvite[],
  () => (Lockr.get(INVITE_TOKEN_ID) || {}) as Record<string, unknown>,
  (invites, declinedInvites) => invites.filter((invite) => !declinedInvites[invite.token]),
);
